export function FieldLabel({
  children,
  optional,
}: {
  children: React.ReactNode;
  optional?: boolean;
}) {
  return (
    <label className="text-sm text-foreground">
      {children}
      {optional && <span className="text-foreground-muted"> (optional)</span>}
    </label>
  );
}
